import './styles/details/index.scss';

import { app } from './bootstrap';

import MainController from './controllers/details/main_manual_controller';
import FullScreenGalleryController from './controllers/details/fullscreen_gallery_manual_controller';
import GalleryController from './controllers/details/gallery_manual_controller';

app.register('details--main', MainController);
app.register('details--gallery', GalleryController);
app.register('details--fullscreen-gallery', FullScreenGalleryController);
